// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const zygarde_complete: PokeData = {
  "id": 10120,
  "name": "zygarde-complete",
  "height": 45,
  "weight": 6100,
  "base_experience": 354,
  "types": [
    PokeType.DRAGON,
    PokeType.GROUND
  ],
  "api_moves": [
    "bind",
    "bite",
    "earthquake",
    "dig",
    "haze",
    "glare",
    "outrage",
    "sandstorm",
    "safeguard",
    "dragon-breath",
    "crunch",
    "camouflage",
    "dragon-pulse",
    "coil",
    "bulldoze",
    "thousand-arrows",
    "thousand-waves",
    "lands-wrath",
    "core-enforcer"
  ],
  "moves": [
    "bite",
    "earthquake",
    "outrage",
    "sandstorm",
    "dragon-breath",
    "crunch",
    "dragon-pulse",
    "dragon-fang",
    "draco-meteor",
    "dragon-claw",
    "inner-spirit",
    "great-roar",
    "dragon-dance"
  ],
  "evolution_chain": {
    "id": 370,
    "item": null,
    "species": [
      {
        "name": "zygarde",
        "order": 718,
        "types": [
          PokeType.DRAGON,
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 187,
    "speed": 98,
    "ability_power": 115
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
